import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from 'react-bootstrap-dialog';
import { File } from 'components/FileUploadMultiple';
import { Row, Col, Modal, Form, Button } from 'react-bootstrap';
import {Currency,DollarCurrency,EuroCurrency} from 'helpers/Currency';
import { parseDateBR } from 'helpers/date';
import { connect } from 'react-redux';
import { ASYNC_INVOICE_APPROVAL } from 'store';
import './style.css';
import Can from 'components/Can';
import Loading from 'components/Loading';
import Input from 'helpers/Input';
import FormSelectActions from 'components/S3Explorer/Form/FormSelectActions';

const ModalApproval = ({ data, invoiceApproval, show, handleHideModalAUX, handleUpdate,showBtns, user,setLoad, loading, is_event
 }) => {
  const [showModal, setShowModal] = useState(show?show:false);

  const { t } = useTranslation();
  let dialog;

  const handleHideModal = () => {
    handleHideModalAUX()
    setShowModal(false);
  };

  const approvedInvoice = (invoiceId, whoApproved) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success', 
      defaultButtonClassName: 'btn-danger',
    });

    dialog.show({
      title: t('title:approval invoice'),
      body: t('phrase:are you sure?'),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          // setLoad(true);
          const formData = new FormData();
          //formData.append('_method', 'put');
          if(is_event == 1){
            formData.append('is_event', is_event);
          }
          formData.append('approval', true);
          formData.append('id', invoiceId);
          formData.append('expense_description_id', invoiceId);
          formData.append('status_id', 8);
          formData.append('user_id', user.id);
          formData.append('profile_id', user.profiles[0]?user.profiles[0].id:null);          
          formData.append('is_advance', data.is_advance)
          //formData.append('first_approval', 1);
          //formData.append('who_approved', whoApproved);
          //formData.append('second_approval', whoApproved === 'Fabio' ? 1 : 0);
          invoiceApproval(formData);
          handleHideModal();
          handleUpdate();
        }),
      ],
      bgSize: 'small',
    });
  };

  const disapprovedInvoice = (invoiceId, whoApproved) => {
    Dialog.setOptions({
      defaultOkLabel: t('label:yes'),
      defaultCancelLabel: t('label:no'),
      primaryClassName: 'btn-success',
      defaultButtonClassName: 'btn-danger',
    });

    var comment = '';

    dialog.show({
      title: t('title:disapproval invoice'),
      body: (
      <>
      {t('phrase:are you sure?')}
      <Form.Group controlId="exampleForm.ControlTextarea1">
        <Form.Label>Comentário:</Form.Label>
        <Form.Control as="textarea" rows="3" onChange={e=>comment = e.target.value}/>
      </Form.Group>
      </>
      ),
      actions: [
        Dialog.CancelAction(),
        Dialog.OKAction(() => {
          // setLoad(true);
          const formData = new FormData();
          //formData.append('_method', 'put');
          if(is_event == 1){
            formData.append('is_event', is_event);
          }
          formData.append('approval', true);
          formData.append('id', invoiceId);
          formData.append('expense_description_id', invoiceId);
          formData.append('status_id', 7);
          formData.append('user_id', user.id);
          formData.append('profile_id', user.profiles[0]?user.profiles[0].id:null);
          formData.append('description', comment);
          formData.append('is_advance', data.is_advance)
          //formData.append('first_approval', 1);
          //formData.append('who_approved', whoApproved);
          //formData.append('second_approval', whoApproved === 'Fabio' ? 1 : 0);
          invoiceApproval(formData);
          handleHideModal();
          handleUpdate();
        }),
      ],
      bgSize: 'small',
    });
  };

  const getStatus = () => {
    let approvations = data.approval_history;
    const getIcon = () => {
      if(approvations.filter(a=>a.status_id===8).length > 0){
        return <i className={"fas fa-chevron-circle-right bar-status-icon "+getProgress()+'-icon'}
        data-tip={``}></i>
      }else{
        //<i className="fas fa-chevron-circle-right"></i>
        return <i className={"fas fa-exclamation-circle bar-status-icon bar-status-icon-orange "+getProgress()+'-icon'}
        data-tip={``}></i>
      }
    }
    const getProgress = () => {
      if(approvations.filter(a=>a.status_id===8).length > 0){
        return ' progress-50'
      }else{
        return '';
      }
    }
    return (<>
      <div className='bar-status'>
        <div className={'bar-status-progress'+getProgress()}></div>
        {getIcon()}
      </div>
      <Row className="mt-2">
        <Col className="text-left"><strong>Aguardando Aprovação</strong></Col>
        {approvations.length > 1?(
          <Col className="text-center"><strong>Aguardando Segunda Aprovação</strong></Col>
        ):''}
        <Col className="text-right"><strong>Aprovada</strong></Col>
      </Row>
    </>);
  }
  
  const getcurrency = (value) => {
    switch (data.currency) {
      case 1:
        return <Currency value={value} disabled />;
        break;
      case 2:
        return <DollarCurrency value={value} disabled />;
        break;
      case 3:
        return <EuroCurrency value={value} disabled />;
        break;
      default:
        return <Currency value={value} disabled />;
        break;
    }
  }

  const showButton = (aprovals_profile) => {
    let list_ids = aprovals_profile.split(',').map(id=>parseInt(id));
    return list_ids.includes(user.profiles[0].id);
  }

  return (
    <>
      <Dialog
        ref={(component) => {
          dialog = component;
        }}
      />
      <Modal size="lg" show={showModal} onHide={handleHideModal}>
        <Modal.Header closeButton>#{data.id}</Modal.Header>
        <Modal.Body>
          <Row className='p-3'><Col xs="12">
          {getStatus()}
          </Col></Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>Analista</Form.Label>
                <Form.Control value={data.creator} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>Fabricante</Form.Label>                
                <Form.Control value={data.company} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:service provider')}</Form.Label>
                <Form.Control value={data.service_provider} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:registered number')}</Form.Label>                
                <Input.CNPJ value={data.document} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:invoice number')}</Form.Label>
                <Form.Control value={data.invoice_number} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:expiry')}</Form.Label>
                <Form.Control disabled value={data.due_date && parseDateBR(data.due_date)} />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:issuance_date')}</Form.Label>
                <Form.Control disabled value={data.issuance_date && parseDateBR(data.issuance_date)} />
              </Form.Group>
            </Col>
          </Row>
          <Row className="mt-2 mb-1">
            <Col>
              <h5>{t('title:project info')}</h5>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:nature')}</Form.Label>
                <Form.Control value={data.nature} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:cost center')}</Form.Label>
                <Form.Control value={data.cost_center} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project')}</Form.Label>
                <Form.Control value={data.project} disabled />
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:project action')}</Form.Label>
                <Form.Control value={data.project_action} disabled />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Reembolsável</Form.Label>
                {getcurrency(data.value)}
              </Form.Group>
            </Col>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:value')} - Não Reembolsável</Form.Label>
                {getcurrency(data.non_refundable)}
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
              <Form.Group>
                <Form.Label>{t('label:brief description')}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows="4"
                  value={data.description}
                  disabled
                />
              </Form.Group>
            </Col>
          </Row>
          <Row>
            <Col>
            {data.files?(data.files.map((file=>
              <File
                key={file.id}
                extension={file.extension}
                comment={file.comment}
                uri={file.uri}
                name={file.name}
              />
            ))
            ):(
              <File
                key={data.files.id}
                extension={data.files.extension}
                comment={data.files.comment}
                uri={data.files.uri}
              />
            )}
            </Col>
          </Row>
          {data.vinculated && data.vinculated.length > 0?(
            <Row className="p-1">
              <FormSelectActions 
              disabled={true} 
              list={[]}
              selected={data.vinculated}
              value_nf={data.value}/>
            </Row>
          ):''}
        </Modal.Body>
        {showButton(data.aprovals_profile)?
          <Modal.Footer style={{display:showBtns?'':'none'}}>
            <Button
              size="sm"
              variant="dark"
              onClick={() => approvedInvoice(data.id, data.permission)}
            >
              {t('label:approve')}
            </Button>
            <Button
              size="sm"
              variant="dark"
              onClick={() => disapprovedInvoice(data.id, data.permission)}
            >
              {t('label:disapprove')}
            </Button>
          </Modal.Footer>
        :<></>}
      </Modal>
      {/* <Button
        size="sm"
        variant="light"
        alt={t('title:approval invoice')}
        title={t('title:approval invoice')}
        onClick={() => setShowModal(true)}
      >
      </Button> */}
    </>
  );
};

const mapStateToProps = (state) => ({
  loading: state.loading,
});

const mapDispatchToProps = (dispatch) => ({
  invoiceApproval: (payload) =>
    dispatch({ type: ASYNC_INVOICE_APPROVAL, payload }),
});

const connectRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(ModalApproval);

export default connectRedux;